import { Row, Col } from '@everlywell/leaves';
import React from 'react';
import { generateKey } from 'utils/helpers';
import { IResource, RESOURCES_TYPES } from 'utils/types';

import * as S from './styles';

export interface IPostCard {
  resource: IResource;
}

const PostCard: React.FC<IPostCard> = ({ resource }: IPostCard) => {
  let resourceHref;

  switch (resource.type) {
    case RESOURCES_TYPES.CASE_STUDY:
      resourceHref = `/learnings/${resource.cta?.url}`;
      break;

    case RESOURCES_TYPES.WHITE_PAPER:
      resourceHref = resource.cta?.url;
      break;

    default:
      resourceHref = `/learnings/${resource.slug}`;
      break;
  }

  return (
    <S.Resource key={generateKey()} data-testid="resource">
      <Row middle="xs">
        <Col xs={12} md={4}>
          {resource.image ? (
            <S.Image
              image={resource.image.gatsbyImageData}
              alt={resource.image.title}
            />
          ) : null}
        </Col>
        <Col xs={12} md={8}>
          {resource.type ? <S.Type>{resource.type}</S.Type> : null}
          {resource.title ? <S.Title>{resource.title}</S.Title> : null}
          {resource.summary ? (
            <S.Summary>{resource.summary?.summary}</S.Summary>
          ) : null}
          {resource.cta ? (
            <S.CTA
              // link page url with slug
              href={resourceHref}
              target={
                resource.type === RESOURCES_TYPES.CASE_STUDY
                  ? '_self'
                  : '_blank'
              }
              rel={
                resource.type === RESOURCES_TYPES.CASE_STUDY
                  ? undefined
                  : 'nofollow noopener noreferrer'
              }
            >
              {resource.cta?.text}
            </S.CTA>
          ) : null}
        </Col>
      </Row>
    </S.Resource>
  );
};

export default PostCard;
